/* eslint-disable react/self-closing-comp */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ListMenu, MenuMobileList, SideBar } from "@finanedi.es/storybook"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import TokenSender from "@legacy/@gedesco/reactcomponentsgdc-v2.token-manager/TokenSender"
import useOnClickOutside from "common/hooks/useOnClickOutside"
import useRedirectToExternalApp from "common/hooks/useRedirectToExternalApp"
import ImportDownloadModal from "features/Documentos/components/DocumentosActions/modals/ImportDownloadModal"
import ImportarFacturasExcelModal from "features/Importar/pages/Factura/ImportarFacturasExcelModal"
import ImportarFacturasEModal from "features/Importar/pages/Factura/ImportarFacturasModal"
import useWindowSize from "hooks/useWindowSize"
import { ProgressBar } from "primereact/progressbar"
import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import DirectAccess from "../DirectAccess/DirectAccess"
import { getOptionFacturasModal } from "../DirectAccess/constant"
import { KEYS, getValidUrl } from "../MdfDialog/constants"
import Modal from "../Modal/Modal"
import { MOBILE_MENU_LIST, SIDE_BAR_MENU } from "./constant"

type AllowedApps = "GEFINTECH" | "GEFINTECH_INVOICES"

interface settingsTemplate {
  title: string
  stylesheet: string
  mainLogo: string
  sidebarLogoSmall: string
  sidebarLogoBig: string
  crm: string
  erp: string
  ops: string
  primary: string
  secondary: string
  bicolorIcon: string
  crmIsotipo: string
  opsIsotipo: string
  favicon: string
  pdf: $TSMigrationFixMe
  xml: $TSMigrationFixMe
  xlxs: $TSMigrationFixMe
  edi: $TSMigrationFixMe
  emptyAprovement: $TSMigrationFixMe
}

interface SideBarTemplate {
  setInvitation: (any: $TSMigrationFixMe) => void
  settings: settingsTemplate
  goTo: (path: string, mode: $TSMigrationFixMe) => void
  pathname: string
}

const SideBarInnova = ({
  setInvitation,
  settings,
  goTo,
  pathname,
}: SideBarTemplate) => {
  const { t } = useTranslation()
  const {
    showModal,
    handleAplications,
    progressValue,
    toggleShowModal,
    message,
    aplicationKey,
  } = useRedirectToExternalApp(KEYS.GEFINTECH)
  const [collapsed, setCollapsed] = useState(false)
  const [collapsedSubMenus, setCollapsedSubMenus] = useState(false)
  const [showModalImport, setShowModalImport] = useState(false)
  const [swicthToSideBar, setSwicthToSideBar] = useState(false)

  const [showMenuNuevosDocumentos, setShowMenuNuevosDocumentos] =
    useState(false)

  const { width } = useWindowSize()
  const isMobileView = width < 768
  const openModalImport = (): void => {
    setShowModalImport(true)
  }

  useEffect(() => {
    if (width >= 1024 && width <= 1279) {
      setCollapsed(false)
    }
  }, [width])

  const toggleCollapsedButton = () => {
    setCollapsedSubMenus(!collapsedSubMenus)
    setTimeout(() => {
      setCollapsed(!collapsed)
    }, 300)
  }

  const handleRedirect = (appKey: $TSMigrationFixMe) => {
    handleAplications(appKey)
    toggleShowModal(!showModal)
  }

  const collapseMenuRedirect = (
    path: string,
    status?: $TSMigrationFixMe,
    withSubMenu?: boolean
  ): void => {
    withSubMenu && setCollapsedSubMenus(!collapsedSubMenus)
    width < 1024 && setCollapsed(false)
    goTo(path, status)
    isMobileView && showMenuNuevosDocumentos && setSwicthToSideBar(false)
  }

  const closeMobile = () => {
    width < 1024 && setCollapsed(false)
    width > 1024 && setCollapsedSubMenus(!collapsedSubMenus)
  }

  const sideBarRef = useRef<HTMLDivElement>(null)

  useOnClickOutside(sideBarRef, closeMobile, false, "sideBarInnova")

  useEffect(() => {
    if (isMobileView && !collapsed) {
      setSwicthToSideBar(false)
    }
  }, [isMobileView, collapsed])

  return (
    <>
      <SideBar
        body={
          <div
            className={`tw-flex tw-flex-col tw-h-full lg:tw-py-8 ${
              isMobileView && !swicthToSideBar ? "tw-pt-6" : "tw-pt-2"
            }`}
            ref={sideBarRef}
          >
            <img
              src={
                !collapsed
                  ? settings?.sidebarLogoSmall
                  : settings?.sidebarLogoBig
              }
              className={`${
                !collapsed
                  ? "tw-mx-auto tw-w-10 tw-h-16"
                  : "tw-w-56 tw-h-10 tw-mx-8 tw-mb-6 tw-hidden lg:tw-block"
              } tw-transition-all tw-duration-500 tw-ease-linear`}
              alt='Logo Finanedi'
            />
            <div className='custom-scrollbar tw-h-full'>
              {isMobileView && !swicthToSideBar ? (
                <MenuMobileList
                  menuItems={MOBILE_MENU_LIST({
                    action: collapseMenuRedirect,
                    t,
                  })}
                  buttonFullMenuLabel={`${t("nav.fullMenu")}`}
                  handlerSwitchSideBarMobile={() => setSwicthToSideBar(true)}
                />
              ) : (
                <ListMenu
                  sectionList={SIDE_BAR_MENU}
                  showList
                  expanded={collapsed}
                  showSubMenu={collapsedSubMenus}
                  action={collapseMenuRedirect}
                  pathname={pathname}
                  modals={{
                    openModalImport,
                    setShowMenuNuevosDocumentos,
                    handleRedirect,
                    setCollapsed,
                    setInvitation,
                  }}
                />
              )}
            </div>
          </div>
        }
        buttonIcon={
          <FontAwesomeIcon
            className='card-approval-icon tw-w-6 tw-h-6 tw-decoration-inherit tw-text-white lg:tw-text-primary'
            icon={["fal", "bars"]}
          />
        }
        classSideBar={`${
          isMobileView && !swicthToSideBar
            ? "tw-bg-[#F9FAFB] tw-px-4"
            : "tw-bg-primary tw-px-2"
        } tw-absolute  tw-flex-col tw-min-w-[96px] tw-w-[96px] tw-top-[68px] lg:tw-top-[0px] tw-inset-0 tw-z-50 lg:tw-static lg:tw-inset-auto lg:tw-z-auto ${
          isMobileView && !swicthToSideBar
            ? collapsed
              ? "tw-w-full"
              : "tw-hidden"
            : collapsed
            ? "!tw-min-w-[300px] tw-w-[300px]"
            : "tw-hidden"
        }  lg:tw-block
              md:tw-transition-all md:tw-duration-500 md:tw-ease-linear
              tw-order-first  tw-pb-2 lg:!tw-h-screen`}
        toggleCollapsedButton={toggleCollapsedButton}
        elementId='principal-body'
        id='sideBarInnova'
        classNameIcon='tw-bg-transparent tw-border-0 tw-flex tw-items-center tw-justify-center tw-p-0 tw-w-16 tw-h-16 tw-text-white lg:tw-text-primary tw-block lg:tw-hidden xl:tw-block'
      />
      <ImportarFacturasExcelModal />
      <ImportarFacturasEModal />
      <ImportDownloadModal
        onHide={() => setShowModalImport(false)}
        visible={showModalImport}
        title={t("crear.factura.finance.importLabel")}
        subtitle={t("crear.factura.finance.importMsgLabel")}
        options={getOptionFacturasModal(collapseMenuRedirect, settings)}
      />
      <TokenSender
        message={message}
        targetUrl={import.meta.env.REACT_APP_ACCOUNTS || ""}
      />
      <DirectAccess
        showMenuNuevosDocumentos={showMenuNuevosDocumentos}
        setShowMenuNuevosDocumentos={setShowMenuNuevosDocumentos}
        settings={settings}
      />
      {/* // TODO: estos modales habria que revisar si sirven para algo */}
      <Modal
        size='small'
        className='mercado-facturas-dialog'
        visible={showModal}
        onHide={toggleShowModal}
        closable={false}
        draggable={false}
        header={
          <div className='mercado-facturas-dialog__content-header'>
            <img
              alt='Logo de ERP'
              src={getValidUrl(settings)?.[aplicationKey as AllowedApps]?.logo}
            />
          </div>
        }
      >
        <ProgressBar
          value={progressValue}
          showValue={false}
        />
      </Modal>
    </>
  )
}

export default SideBarInnova
